import { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'fec_theme';

export const THEMES = [
  { id: 'light',  label: 'Light',  swatches: ['#ffffff', '#f1f5f9', '#eab308'] },
  { id: 'dark',   label: 'Dark',   swatches: ['#0f172a', '#1e293b', '#eab308'] },
  { id: 'ocean',  label: 'Ocean',  swatches: ['#e0f2fe', '#0284c7', '#14b8a6'] },
  { id: 'forest', label: 'Forest', swatches: ['#f0fdf4', '#166534', '#f97316'] },
  { id: 'sunset', label: 'Sunset', swatches: ['#fff7ed', '#c2410c', '#db2777'] },
];

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, _setTheme] = useState(() => {
    try {
      const t = localStorage.getItem(STORAGE_KEY);
      return THEMES.some(x => x.id === t) ? t : 'light';
    } catch (_) {
      return 'light';
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch (_) { /* ignore */ }
  }, [theme]);

  const setTheme = (id) => {
    if (THEMES.some(t => t.id === id)) _setTheme(id);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
}
